import { css } from 'styled-components';
import { HeadingLevels } from '../../enums/headings.js';
import '../../themes/alert.js';
import '../../themes/button.js';
import '../../themes/checkbox.js';
import '../../themes/divider.js';
import '../../themes/dropdown.js';
import '../../themes/fieldset.js';
import { fontFamilyBook, fontSizeXxSmall, fontWeightBook, fontSizeSmall, fontSizeMedium, fontSizeLarge, fontFamilyMedium, fontSizeXLarge, fontWeightMedium, fontFamilyBold, fontSizeXxLarge, fontWeightBold } from '../../themes/fonts.js';
import '../../themes/input.js';
import '../../themes/list.js';
import '../../themes/listbox.js';
import '../../themes/loader.js';
import '../../themes/option.js';
import '../../themes/popout.js';
import '../../themes/switch.js';
import '../../themes/themes.js';
import '../../themes/tooltip.js';

const getHeadingLevel = (options)=>{
    const { level } = options;
    switch(level){
        case HeadingLevels.h1:
            {
                return css`
        font-family: ${fontFamilyBold};
        font-size: ${fontSizeXxLarge}px;
        font-weight: ${fontWeightBold};
        line-height: 50px;
      `;
            }
        case HeadingLevels.h2:
            {
                return css`
        font-family: ${fontFamilyMedium};
        font-size: ${fontSizeXLarge}px;
        font-weight: ${fontWeightMedium};
        line-height: 40px;
      `;
            }
        case HeadingLevels.h3:
            {
                return css`
        font-family: ${fontFamilyBook};
        font-size: ${fontSizeLarge}px;
        font-weight: ${fontWeightBook};
        line-height: 28px;
      `;
            }
        case HeadingLevels.h4:
            {
                return css`
        font-family: ${fontFamilyBook};
        font-size: ${fontSizeMedium}px;
        font-weight: ${fontWeightBook};
        line-height: 24px;
      `;
            }
        case HeadingLevels.h5:
            {
                return css`
        font-family: ${fontFamilyBook};
        font-size: ${fontSizeSmall}px;
        font-weight: ${fontWeightBook};
        line-height: 22px;
      `;
            }
        // HeadingLevels.h6
        default:
            {
                return css`
        font-family: ${fontFamilyBook};
        font-size: ${fontSizeXxSmall}px;
        font-weight: ${fontWeightBook};
        line-height: 18px;
      `;
            }
    }
};

export { getHeadingLevel };
//# sourceMappingURL=heading.js.map
